module.exports = __webpack_public_path__ + "images/8d650c37871ca02b6ad69cbb6a3a20f9-logo_white.png";